import styled from 'styled-components';

export default styled.div`
  display: block;
  position: absolute;
  top: 5%;
  left: 110%;
  right: auto;
  
  @media screen and (max-width: 991.98px) {
    display: none;
  }
`;
